import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { get, put } from "../services/apiClient";

export interface BillingSettingsRow {
  id: string;
  defaultTrialDays: number;
  gracePeriodDays: number;
  retryScheduleDays: number[];
  maxRetries: number;
  commissionRate: number | string;
  activeGateway: "RAZORPAY" | "STRIPE" | "MANUAL" | string;
  failedTrialAction: "expire" | "downgrade_free" | string;
  updatedAt?: string;
}

export type UpdateBillingSettingsInput = Partial<
  Pick<
    BillingSettingsRow,
    | "defaultTrialDays"
    | "gracePeriodDays"
    | "retryScheduleDays"
    | "maxRetries"
    | "commissionRate"
    | "activeGateway"
    | "failedTrialAction"
  >
>;

const KEY = ["billing-settings"] as const;

export const useBillingSettings = () =>
  useQuery<BillingSettingsRow>({
    queryKey: KEY,
    queryFn: () => get<BillingSettingsRow>("/admin/billing-settings"),
  });

export const useUpdateBillingSettings = () => {
  const qc = useQueryClient();
  return useMutation<BillingSettingsRow, Error, UpdateBillingSettingsInput>({
    mutationFn: (data) =>
      put<BillingSettingsRow>("/admin/billing-settings", data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
};
